import { HomeyAPI } from 'homey-api';
import { v4 as uuid } from 'uuid';

import { RouteManager } from '../../RouteManager';

import { flowFoldersDraftStore } from '../../store/flow-folders/FlowFoldersDraftStore.ts';

import { useI18n } from '../../hooks/useI18nFormatters';
import { useApi } from '../../store/SelectedHomeyStore.hooks';

import { glyph } from '../../theme/glyph';

import { TabAddMenu } from '../../components/sub-navigation/TabAddMenu';

import { useFlowFilter } from './FlowFilterContext';

const KEYS = {
  FLOW: 'FLOW',
  ADVANCED_FLOW: 'ADVANCED_FLOW',
  FOLDER: 'FOLDER',
};

export function FlowsAddMenu() {
  const { i18n } = useI18n();
  const { api, features } = useApi();
  const clearFilter = useFlowFilter((state) => state.clearFilter);

  const items = [
    {
      key: KEYS.FLOW,
      label: i18n.messageFormatter('flow.newFlow'),
      icon: glyph.system.flow,
    },
    {
      key: KEYS.ADVANCED_FLOW,
      label: i18n.messageFormatter('flow.newAdvancedFlow'),
      icon: glyph.system.advancedFlow,
    },
    {
      key: KEYS.FOLDER,
      label: i18n.messageFormatter('flow.newFolder'),
      icon: glyph.core.folderFill,
    },
  ];

  function handleAction(key) {
    switch (key) {
      case KEYS.FLOW:
        RouteManager.toFlow(`create?id=${uuid()}`);
        break;
      case KEYS.ADVANCED_FLOW: {
        if (features?.isCloudPremium === true) {
          RouteManager.toAdvancedFlow(`create?id=${uuid()}`);
          return;
        }

        if (HomeyAPI.isHomeyAPIV3Cloud(api) === true) {
          RouteManager.toFlows(RouteManager.getStateForPremiumRequiredDialog());
          return;
        }

        const hasAdvancedFlowLicense = features?.advancedFlow.hasLicense;

        if (hasAdvancedFlowLicense === false) {
          RouteManager.toNewFlow({ viewId: 'purchase' });
          return;
        }

        const hasAdvancedFlowVersion = features?.advancedFlow.hasVersion;

        if (hasAdvancedFlowVersion === false) {
          RouteManager.toNewFlow({ viewId: 'update' });
          return;
        }

        RouteManager.toAdvancedFlow(`create?id=${uuid()}`);
        break;
      }
      case KEYS.FOLDER:
        // Clear any active search/chip filter so the empty-named draft folder is
        // not filtered out of the tree before its inline rename input can mount.
        clearFilter();
        flowFoldersDraftStore.setFlowFoldersDraft({
          flowFolders: {
            'tmp-id': {
              id: 'tmp-id',
              name: '',
              parent: null,
            },
          },
        });
        break;
      default:
        break;
    }
  }

  return (
    <TabAddMenu
      ariaLabel="Flows Add Menu"
      title={i18n.messageFormatter('header.add')}
      items={items}
      onAction={handleAction}
    />
  );
}
